import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object } from "yup";
import { FuturePurchaseStatusFormValue } from "src/models/FuturePurchase.model";
import {
  useGetFuturePurchaseByIdQuery,
  useUpdateFuturePurchaseByIdMutation,
} from "src/services/FuturePurchaseService";
import { showToast } from "src/utils/showToaster";
import StatusForm from "../Layouts/StatusForm";

type Props = {
  onClose: () => void;
  selectedFuturePurchaseId: string;
};
const EditStatusWrapper = ({ onClose, selectedFuturePurchaseId }: Props) => {
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } = useGetFuturePurchaseByIdQuery(
    selectedFuturePurchaseId
  );
  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  // Form Initial Values
  const initialValues: FuturePurchaseStatusFormValue = {
    status: { label: items?.status, value: items?.status },
  };

  // Validation Schema
  const validationSchema = object().shape({
    status: object().required("Please select a status"),
  });

  const [updateStatus] = useUpdateFuturePurchaseByIdMutation();

  // Handle Submit
  const handleSubmit = (
    values: FuturePurchaseStatusFormValue,
    { setSubmitting, resetForm }: FormikHelpers<FuturePurchaseStatusFormValue>
  ) => {
    const fomattedValues = {
      status: values.status.value,
    };
    updateStatus({ id: selectedFuturePurchaseId, body: fomattedValues }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <StatusForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditStatusWrapper;
